
import {
  MDBBtn, MDBCol,
  MDBLightbox, MDBLightboxItem,
  MDBModal, MDBModalBody, MDBModalContent, MDBModalDialog, MDBModalFooter, MDBModalHeader,MDBSmoothScroll,
  MDBModalTitle,
  MDBRow,
  MDBTypography
} from 'mdb-react-ui-kit';
import PropTypes from 'prop-types';
import React, {useState,useRef } from 'react';
import EntityDetails from '../entity/EntityDetails';
import ItemView from "../products/ItemView";

const EntityDetailModal = ({isSecondModalOpen,setIsSecondModalOpen,viewItem, setViewItem}) => {

    const [modalOpen, setModalOpen] = useState(false);
    const [historyModalOpen, setHistoryModalOpen] = useState(false);
    const [viewModalOpen, setViewModalOpen] = useState(false);

    const sectionFiveRef = useRef(null);
    const containerFourRef = useRef(null);
    const [isEntityHistorySuccess, setIsEntityHistorySuccess] = useState(false);
    const [showLightbox, setShowLightbox] = useState(false);
   

    const [receiptImages, setReceiptImages] = useState([]);
    const [imageIds, setImageIds] = useState([]);
  
  const handleModalClose2 = () => {
    setIsSecondModalOpen(false);
    setModalOpen(false);
    setHistoryModalOpen(false);
  };
  const handleBackdropClick = (e) => {
    if (e.target === e.currentTarget) {
      e.stopPropagation();
    }
  };

  const handleViewModalClose = () => {
    setViewItem({});
    toggleViewModal();
  };

  const toggleViewModal = () => {
    setViewModalOpen(!viewModalOpen);
  };

 
    return (
       
    
    
          <section>
{((isSecondModalOpen || historyModalOpen) && viewItem?.historyId) ? 
    <MDBModal closeOnEsc={() => { setHistoryModalOpen(false); setIsSecondModalOpen(false); handleBackdropClick(); handleModalClose2() }}

    onClose={() => { setHistoryModalOpen(false); setIsSecondModalOpen(false); handleBackdropClick(); handleModalClose2();  }}
      key={`MDBModal-2-${isSecondModalOpen}`}
     setOpen={setIsSecondModalOpen}
      open={isSecondModalOpen || historyModalOpen}
      onClick={handleBackdropClick}
      toggle={handleModalClose2} staticBackdrop={true}
      
    >
      <MDBModalDialog centered={true} size="xl" staticBackdrop>

        <MDBModalContent>
          <MDBModalHeader>
            <MDBModalTitle>{historyModalOpen ? 'Update History' : 'Detailed View'}  <MDBTypography tag='mark' className='lead mb-0'> {viewItem.name}</MDBTypography></MDBModalTitle>


           
            <MDBBtn
              className='btn-close'
              color='none'
              onClick={handleModalClose2}
            ></MDBBtn>
          </MDBModalHeader>
          <MDBModalBody>
       
          <MDBRow>
              <MDBCol md='4'  className='text-center , justify-content-center align-items-center d-flex' style={{ overflowX: 'auto', overflowY: 'auto', whiteSpace: 'nowrap', textAlign: 'center' ,height: '800px'}}>
              <MDBSmoothScroll
            targetRef={sectionFiveRef}
            containerRef={containerFourRef}
            duration={1000}
            easing={(t) => {
              t /= 0.5;
              if (t < 1) return 0.5 * t * t * t * t;
              t -= 2;
              return -(t * t * t * t - 2) / 2;
            }}
          >
          {(receiptImages?.length > 0) && receiptImages?.map((selectedImage, index) => (
            
          
              <MDBLightbox 
                key={index}
                className='badge badge-warning rounded ms-2 text-center , justify-content-center align-items-center '
                onClose={() => setShowLightbox(false)} onSlide={() => setShowLightbox(false)}
              >
                <MDBLightboxItem className='img-thumbnail  shadow-1-strong rounded '
                  zoomLevel={0.5}
                  src={selectedImage.thumbnail ? selectedImage.thumbnail : "preview"}
                  fullscreenSrc={selectedImage.url}
                  onClose={() => setShowLightbox(false)}
                  title={selectedImage.dateKey} onSlide={() => setShowLightbox(false)}
                />
              </MDBLightbox>
           
            ))
            }
            </MDBSmoothScroll>
         </MDBCol>
<MDBCol md='8' style={{ overflowX: 'auto', overflowY: 'auto', whiteSpace: 'nowrap', textAlign: 'center' ,height: '800px', minHeight:'800px'}}> 
 
            <EntityDetails currentItem={viewItem} isEdit={historyModalOpen} setIsEntityHistorySuccess={setIsEntityHistorySuccess} setIsEdit={setHistoryModalOpen} showLightbox={showLightbox} setShowLightbox={setShowLightbox} receiptImages={receiptImages} setReceiptImages={setReceiptImages} setImageIds={setImageIds}/>
</MDBCol>
</MDBRow>


          </MDBModalBody>
          {!historyModalOpen && <MDBModalFooter>
            <div style={{ display: 'flex', justifyContent: 'center', width: '100%' }}>
              <MDBBtn color="success" className="mb-4 mb-md-0 me-2 responsive-button" onClick={() => {

                setHistoryModalOpen(true);
              }}>
                edit
              </MDBBtn>

            </div>
          </MDBModalFooter>}

        </MDBModalContent>
      </MDBModalDialog>
    </MDBModal>
   :
    <ItemView key={`ItemView-${viewModalOpen}`} item={viewItem} open={viewModalOpen && isSecondModalOpen} handleViewModalClose={handleViewModalClose} />}

    </section>
    );

};

EntityDetailModal.propTypes = {
    isSecondModalOpen:PropTypes.bool,
    setIsSecondModalOpen:PropTypes.func,
    viewItem:PropTypes.object,
    setViewItem:PropTypes.func,
};

export default EntityDetailModal;